(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["koios-benefit-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var INITED = 'data-kbc-init';

    function initRoot(root) {
      if (!root || root.getAttribute(INITED) === 'true') return;

      var carousel = root.querySelector('[data-kbc-carousel]');
      if (!carousel) return;

      var viewport = carousel.querySelector('[data-kbc-viewport]');
      var track = carousel.querySelector('[data-kbc-track]');
      var slides = Array.prototype.slice.call(carousel.querySelectorAll('[data-kbc-slide]'));
      if (!viewport || !track || !slides.length) return;

      var prevBtn = carousel.querySelector('[data-kbc-prev]');
      var nextBtn = carousel.querySelector('[data-kbc-next]');
      var dotsWrap = carousel.querySelector('[data-kbc-dots]');
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      var total = slides.length;
      var index = 0;
      var touchStartX = 0;
      var touchDeltaX = 0;

      function stepPx() {
        return viewport.clientWidth;
      }

      function renderDots() {
        if (!dotsWrap) return;
        dotsWrap.innerHTML = '';
        slides.forEach(function (_, i) {
          var li = document.createElement('li');
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'koios-benefit-carousel__dot' + (i === index ? ' is-active' : '');
          btn.setAttribute('role', 'tab');
          btn.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          btn.setAttribute('aria-selected', i === index ? 'true' : 'false');
          btn.addEventListener('click', function () {
            goTo(i);
          });
          li.appendChild(btn);
          dotsWrap.appendChild(li);
        });
      }

      function updateSlidesA11y() {
        slides.forEach(function (slide, i) {
          slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
        });
      }

      function applyTransform(animate) {
        if (!animate || reducedMotion) track.style.transition = 'none';
        else track.style.transition = '';

        track.style.transform = 'translate3d(' + -index * stepPx() + 'px, 0, 0)';

        if (prevBtn) prevBtn.disabled = index <= 0;
        if (nextBtn) nextBtn.disabled = index >= total - 1;

        if (dotsWrap) {
          var dots = dotsWrap.querySelectorAll('.koios-benefit-carousel__dot');
          dots.forEach(function (dot, d) {
            var on = d === index;
            dot.classList.toggle('is-active', on);
            dot.setAttribute('aria-selected', on ? 'true' : 'false');
          });
        }

        updateSlidesA11y();

        if (!animate || reducedMotion) {
          requestAnimationFrame(function () {
            track.style.transition = '';
          });
        }
      }

      function goTo(i, animate) {
        index = Math.max(0, Math.min(total - 1, i));
        applyTransform(animate !== false);
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          goTo(index - 1);
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          goTo(index + 1);
        });
      }

      viewport.addEventListener(
        'touchstart',
        function (e) {
          if (!e.touches.length) return;
          touchStartX = e.touches[0].clientX;
          touchDeltaX = 0;
        },
        { passive: true }
      );
      viewport.addEventListener(
        'touchmove',
        function (e) {
          if (!e.touches.length) return;
          touchDeltaX = e.touches[0].clientX - touchStartX;
        },
        { passive: true }
      );
      viewport.addEventListener(
        'touchend',
        function () {
          if (Math.abs(touchDeltaX) < 48) return;
          if (touchDeltaX < 0) goTo(index + 1);
          else goTo(index - 1);
        },
        { passive: true }
      );

      var resizeTimer;
      window.addEventListener('resize', function onResize() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          applyTransform(false);
        }, 100);
      });

      renderDots();
      applyTransform(false);
      root.setAttribute(INITED, 'true');
    }

    function initAll(container) {
      var scope = container || document;
      var roots = scope.querySelectorAll('[data-koios-benefit-carousel]');
      for (var i = 0; i < roots.length; i++) initRoot(roots[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      if (!event || !event.target) return;
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["koios-bestsellers-stage"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var INITED = 'data-koios-bestsellers-inited';

    function initStage(root) {
      if (!root || root.getAttribute(INITED) === 'true') return;

      var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('[role="tabpanel"]'));
      if (!tabs.length || !panels.length) return;

      function activate(index) {
        tabs.forEach(function (tab, i) {
          var on = i === index;
          tab.classList.toggle('is-active', on);
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (panel, i) {
          var on = i === index;
          panel.classList.toggle('is-active', on);
          if (on) panel.removeAttribute('hidden');
          else panel.setAttribute('hidden', '');
        });
      }

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () {
          activate(i);
        });
      });

      root.setAttribute(INITED, 'true');
    }

    function destroyStage(root) {
      if (!root) return;
      root.removeAttribute(INITED);
    }

    function initAll(scope) {
      var roots = (scope || document).querySelectorAll('[data-koios-bestsellers-stage][data-section-id]');
      for (var i = 0; i < roots.length; i++) {
        destroyStage(roots[i]);
        initStage(roots[i]);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      if (event && event.target) initAll(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      if (!event || !event.target) return;
      event.target.querySelectorAll('[data-koios-bestsellers-stage]').forEach(destroyStage);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["koios-brand-story"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var INITED = 'data-koios-story-inited';

    function initStory(root) {
      if (!root || root.getAttribute(INITED) === 'true') return;
      if (!root.classList.contains('is-reveal')) {
        root.setAttribute(INITED, 'true');
        return;
      }

      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reducedMotion || !('IntersectionObserver' in window)) {
        root.classList.add('is-visible');
        root.setAttribute(INITED, 'true');
        return;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.12 }
      );

      observer.observe(root);
      root.setAttribute(INITED, 'true');
    }

    function initAll(container) {
      var scope = container || document;
      var roots = scope.querySelectorAll('[data-koios-brand-story][data-section-id]');
      for (var i = 0; i < roots.length; i++) initStory(roots[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      if (!event || !event.target) return;
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["koios-category-tiles"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var INITED = 'data-koios-cat-inited';

    function syncColumns(root) {
      if (!root || root.getAttribute('data-auto-columns') !== 'true') return;

      var grid = root.querySelector('.koios-category-tiles__grid');
      if (!grid) return;

      var tiles = grid.querySelectorAll('.koios-category-tiles__tile');
      var count = tiles.length;
      var maxCols = parseInt(root.getAttribute('data-columns-max') || '5', 10);
      var desktop = Math.min(Math.max(count, 1), maxCols);
      var tablet = Math.min(desktop, 3, count || 1);
      var mobile = count <= 1 ? 1 : 2;

      root.style.setProperty('--kct-columns', String(desktop));
      root.style.setProperty('--kct-columns-tablet', String(tablet));
      root.style.setProperty('--kct-columns-mobile', String(mobile));
      grid.setAttribute('data-tile-count', String(count));
    }

    function initRoot(root) {
      if (!root || root.getAttribute(INITED) === 'true') return;
      syncColumns(root);
      root.setAttribute(INITED, 'true');
    }

    function initAll(container) {
      var scope = container || document;
      var roots = scope.querySelectorAll('[data-koios-category-tiles][data-section-id]');
      for (var i = 0; i < roots.length; i++) {
        roots[i].removeAttribute(INITED);
        initRoot(roots[i]);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      if (!event || !event.target) return;
      initAll(event.target);
    });

    document.addEventListener('shopify:block:select', function () {
      initAll();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["koios-hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var INITED = 'data-koios-hero-inited';
    var HLS_JS = 'https://cdn.jsdelivr.net/npm/hls.js@1.5.7/dist/hls.min.js';
    var hlsScriptPromise = null;

    function loadHlsJs() {
      if (window.Hls) return Promise.resolve(window.Hls);
      if (hlsScriptPromise) return hlsScriptPromise;
      hlsScriptPromise = new Promise(function (resolve, reject) {
        var script = document.createElement('script');
        script.src = HLS_JS;
        script.async = true;
        script.onload = function () {
          resolve(window.Hls);
        };
        script.onerror = reject;
        document.head.appendChild(script);
      });
      return hlsScriptPromise;
    }

    function resolvePlaylistUrl(base, relative) {
      if (!relative) return '';
      if (relative.indexOf('http') === 0 || relative.indexOf('//') === 0) return relative;
      var root = base.split('?')[0];
      root = root.substring(0, root.lastIndexOf('/') + 1);
      return root + relative;
    }

    function parseStreamVariants(text, masterUrl) {
      var lines = text.split('\n');
      var variants = [];

      for (var i = 0; i < lines.length; i++) {
        var line = lines[i].trim();
        if (line.indexOf('#EXT-X-STREAM-INF:') !== 0) continue;

        var resMatch = line.match(/RESOLUTION=(\d+)x(\d+)/);
        var bwMatch = line.match(/BANDWIDTH=(\d+)/);
        var uri = (lines[i + 1] || '').trim();
        if (!uri || uri.charAt(0) === '#') continue;

        variants.push({
          width: resMatch ? parseInt(resMatch[1], 10) : 0,
          height: resMatch ? parseInt(resMatch[2], 10) : 0,
          bandwidth: bwMatch ? parseInt(bwMatch[1], 10) : 0,
          url: resolvePlaylistUrl(masterUrl, uri)
        });
      }

      return variants;
    }

    function pickVariant(variants, maxWidth) {
      var eligible = variants.filter(function (variant) {
        return variant.width > 0 && variant.width <= maxWidth;
      });

      if (!eligible.length) eligible = variants.slice();

      eligible.sort(function (a, b) {
        return b.width - a.width || b.bandwidth - a.bandwidth;
      });

      return eligible[0] || null;
    }

    function destroyVideoHls(video) {
      if (!video || !video._koiosHls) return;
      video._koiosHls.destroy();
      video._koiosHls = null;
    }

    function supportsNativeHls(video) {
      return (
        video.canPlayType('application/vnd.apple.mpegurl') ||
        video.canPlayType('application/x-mpegURL')
      );
    }

    function attachMp4Fallback(video) {
      var url = video.getAttribute('data-mp4-fallback');
      if (!url) return false;

      destroyVideoHls(video);
      video.removeAttribute('src');
      var sources = video.querySelectorAll('[data-koios-hero-source]');
      sources.forEach(function (source) {
        source.removeAttribute('src');
      });

      video.src = url;
      if (video.preload === 'none') video.preload = 'auto';
      if (video.networkState === 0 || video.networkState === 3) video.load();
      return true;
    }

    function markVideoLoaded(video) {
      video.setAttribute('data-src-loaded', 'true');
      if (video.preload === 'none') video.preload = 'auto';
    }

    function initHlsPlayback(video, done) {
      if (!video) {
        if (done) done();
        return;
      }

      if (video.getAttribute('data-hls-ready') === 'true') {
        if (done) done();
        return;
      }

      var masterUrl = video.getAttribute('data-hls-master');
      var maxWidth = parseInt(video.getAttribute('data-hls-max-width'), 10) || 1280;

      if (!masterUrl) {
        if (attachMp4Fallback(video)) {
          markVideoLoaded(video);
        }
        if (done) done();
        return;
      }

      fetch(masterUrl)
        .then(function (response) {
          return response.text();
        })
        .then(function (text) {
          var variants = parseStreamVariants(text, masterUrl);
          var choice = pickVariant(variants, maxWidth);

          if (!choice || !choice.url) {
            if (attachMp4Fallback(video)) {
              video.setAttribute('data-hls-ready', 'true');
              markVideoLoaded(video);
            }
            if (done) done();
            return;
          }

          function finishAttach() {
            video.setAttribute('data-hls-ready', 'true');
            markVideoLoaded(video);
            if (done) done();
          }

          function onFail() {
            if (attachMp4Fallback(video)) {
              video.setAttribute('data-hls-ready', 'true');
              markVideoLoaded(video);
              if (done) done();
            }
          }

          if (supportsNativeHls(video)) {
            video.src = choice.url;
            video.addEventListener(
              'error',
              function () {
                onFail();
              },
              { once: true }
            );
            video.load();
            finishAttach();
            return;
          }

          loadHlsJs()
            .then(function (Hls) {
              if (!Hls || !Hls.isSupported()) {
                onFail();
                return;
              }

              destroyVideoHls(video);
              var hls = new Hls({
                enableWorker: true,
                maxBufferLength: 12,
                maxMaxBufferLength: 24
              });
              video._koiosHls = hls;

              hls.on(Hls.Events.ERROR, function (_event, data) {
                if (!data.fatal) return;
                destroyVideoHls(video);
                onFail();
              });

              hls.loadSource(choice.url);
              hls.attachMedia(video);
              hls.on(Hls.Events.MANIFEST_PARSED, finishAttach);
            })
            .catch(onFail);
        })
        .catch(function () {
          if (attachMp4Fallback(video)) {
            video.setAttribute('data-hls-ready', 'true');
            markVideoLoaded(video);
          }
          if (done) done();
        });
    }

    // Attach sources or HLS stream; optional callback when media is ready to play.
    function warmVideo(video, done) {
      if (!video) {
        if (done) done();
        return;
      }

      if (video.getAttribute('data-src-loaded') === 'true') {
        if (video.preload === 'none') video.preload = 'auto';
        if (done) done();
        return;
      }

      var hlsMaster = video.getAttribute('data-hls-master');
      var sources = video.querySelectorAll('[data-koios-hero-source]');
      var legacyUrl = video.getAttribute('data-src');
      var webmSource = video.querySelector('[data-koios-hero-source][type="video/webm"]');

      function afterDomSources() {
        markVideoLoaded(video);
        if (video.networkState === 0 || video.networkState === 3) video.load();
        if (done) done();
      }

      function startHlsOrFallback() {
        if (hlsMaster) {
          initHlsPlayback(video, done);
          return;
        }
        if (attachMp4Fallback(video)) {
          markVideoLoaded(video);
        }
        if (done) done();
      }

      if (webmSource && webmSource.getAttribute('data-src')) {
        webmSource.src = webmSource.getAttribute('data-src');
        markVideoLoaded(video);
        video.load();

        video.addEventListener(
          'error',
          function () {
            startHlsOrFallback();
          },
          { once: true }
        );

        if (done) {
          if (video.readyState >= 2) {
            done();
          } else {
            video.addEventListener('loadeddata', done, { once: true });
            video.addEventListener('canplay', done, { once: true });
          }
        }
        return;
      }

      if (hlsMaster) {
        initHlsPlayback(video, done);
        return;
      }

      if (sources.length) {
        sources.forEach(function (source) {
          var src = source.getAttribute('data-src');
          if (!src) return;
          source.src = src;
        });
        afterDomSources();
        return;
      }

      if (legacyUrl) {
        video.src = legacyUrl;
        afterDomSources();
        return;
      }

      if (done) done();
    }

    // Play as soon as the first frame is decodable — no canplaythrough gate.
    function tryPlay(video) {
      var attempt = video.play();
      if (attempt && attempt.catch) {
        attempt.catch(function () {
          // Autoplay may be blocked; retry once metadata is in, else show controls.
          if (video.readyState < 2) return;
          video.setAttribute('controls', '');
        });
      }
    }

    function startPlayback(video) {
      function afterWarm() {
        if (video.readyState >= 2) {
          tryPlay(video);
          return;
        }

        var kicked = false;
        function kick() {
          if (kicked) return;
          kicked = true;
          video.removeEventListener('loadeddata', kick);
          video.removeEventListener('canplay', kick);
          tryPlay(video);
        }
        video.addEventListener('loadeddata', kick, { once: true });
        video.addEventListener('canplay', kick, { once: true });
      }

      warmVideo(video, afterWarm);
    }

    function preloadNearbyVideos(slides, activeIndex, shouldPreload) {
      if (!shouldPreload) return;
      var targets = [];
      if (activeIndex + 1 < slides.length) targets.push(activeIndex + 1);
      if (activeIndex > 0) targets.push(activeIndex - 1);

      targets.forEach(function (idx) {
        var video = slides[idx].querySelector('[data-koios-hero-video]');
        if (video) warmVideo(video);
      });
    }

    function syncVideos(slides, activeIndex, reducedMotion) {
      slides.forEach(function (slide, i) {
        var video = slide.querySelector('[data-koios-hero-video]');
        if (!video) return;

        if (i !== activeIndex) {
          video.pause();
          if (!reducedMotion) video.removeAttribute('controls');
          return;
        }

        var autoplay = video.getAttribute('data-autoplay') === 'true';

        if (!autoplay || reducedMotion) {
          warmVideo(video);
          if (reducedMotion) video.setAttribute('controls', '');
          return;
        }

        startPlayback(video);
      });
    }

    function pauseAllVideos(slides) {
      slides.forEach(function (slide) {
        var video = slide.querySelector('[data-koios-hero-video]');
        if (video) video.pause();
      });
    }

    function resetVideo(video) {
      if (!video) return;
      destroyVideoHls(video);
      video.pause();
      video.removeAttribute('data-src-loaded');
      video.removeAttribute('data-hls-ready');
    }

    function initHero(root) {
      if (!root || root.getAttribute(INITED) === 'true') return;

      var track = root.querySelector('.koios-hero__track');
      if (!track) return;

      var slides = Array.prototype.slice.call(track.querySelectorAll('.koios-hero__slide'));
      if (slides.length === 0) return;

      var sectionId = root.getAttribute('data-section-id');
      var prevBtn = document.getElementById('KoiosHeroPrev-' + sectionId);
      var nextBtn = document.getElementById('KoiosHeroNext-' + sectionId);
      var dotsWrap = document.getElementById('KoiosHeroDots-' + sectionId);
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var autoplay = root.getAttribute('data-autoplay') === 'true';
      var speed = parseInt(root.getAttribute('data-autoplay-speed'), 10) || 5000;
      var pauseOnVideo = root.getAttribute('data-pause-slideshow-on-video') === 'true';
      var preloadVideos = root.getAttribute('data-preload-videos') === 'true';
      var current = 0;
      var timer = null;
      var touchStartX = 0;

      function renderDots() {
        if (!dotsWrap) return;
        dotsWrap.innerHTML = '';
        slides.forEach(function (_, i) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'koios-hero__dot' + (i === current ? ' is-active' : '');
          dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          dot.setAttribute('role', 'tab');
          dot.setAttribute('aria-selected', i === current ? 'true' : 'false');
          dot.addEventListener('click', function () {
            current = i;
            update();
            restartAuto();
          });
          dotsWrap.appendChild(dot);
        });
      }

      function update() {
        track.style.transform = 'translateX(-' + current * 100 + '%)';
        renderDots();
        syncVideos(slides, current, reducedMotion);
        preloadNearbyVideos(slides, current, preloadVideos);
      }

      function slideHasAutoplayVideo(index) {
        var video = slides[index].querySelector('[data-koios-hero-video][data-autoplay="true"]');
        return !!video;
      }

      function next() {
        current = (current + 1) % slides.length;
        update();
      }

      function prev() {
        current = (current - 1 + slides.length) % slides.length;
        update();
      }

      function stopAuto() {
        if (timer) clearInterval(timer);
        timer = null;
      }

      function startAuto() {
        if (!autoplay || reducedMotion || slides.length <= 1) return;
        if (pauseOnVideo && slideHasAutoplayVideo(current)) return;
        timer = setInterval(next, speed);
      }

      function restartAuto() {
        stopAuto();
        startAuto();
      }

      function attachVisibility() {
        if (root._khVisibility) {
          document.removeEventListener('visibilitychange', root._khVisibility);
        }
        root._khVisibility = function () {
          if (document.hidden) pauseAllVideos(slides);
          else syncVideos(slides, current, reducedMotion);
        };
        document.addEventListener('visibilitychange', root._khVisibility);
      }

      if (slides.length <= 1) {
        syncVideos(slides, 0, reducedMotion);
        attachVisibility();
        root.setAttribute(INITED, 'true');
        return;
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          next();
          restartAuto();
        });
      }
      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          prev();
          restartAuto();
        });
      }

      root.addEventListener(
        'touchstart',
        function (e) {
          touchStartX = e.changedTouches[0].screenX;
        },
        { passive: true }
      );
      root.addEventListener(
        'touchend',
        function (e) {
          var diff = e.changedTouches[0].screenX - touchStartX;
          if (Math.abs(diff) > 50) {
            diff > 0 ? prev() : next();
            restartAuto();
          }
        },
        { passive: true }
      );

      root.addEventListener('mouseenter', stopAuto);
      root.addEventListener('mouseleave', startAuto);

      attachVisibility();

      update();
      startAuto();
      root.setAttribute(INITED, 'true');
    }

    function destroyHero(root) {
      if (!root) return;
      if (root._khVisibility) {
        document.removeEventListener('visibilitychange', root._khVisibility);
        root._khVisibility = null;
      }
      var track = root.querySelector('.koios-hero__track');
      if (track) {
        var slides = track.querySelectorAll('.koios-hero__slide');
        pauseAllVideos(Array.prototype.slice.call(slides));
        Array.prototype.forEach.call(slides, function (slide) {
          resetVideo(slide.querySelector('[data-koios-hero-video]'));
        });
      }
      root.removeAttribute(INITED);
    }

    function initAll(container) {
      var scope = container || document;
      var roots = scope.querySelectorAll('[data-koios-hero][data-section-id]');
      for (var i = 0; i < roots.length; i++) {
        destroyHero(roots[i]);
        initHero(roots[i]);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      if (!event || !event.target) return;
      initAll(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      if (!event || !event.target) return;
      event.target.querySelectorAll('[data-koios-hero][data-section-id]').forEach(destroyHero);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["koios-recipe-showcase"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var INITED = 'data-krs-inited';

    function slidesPerView(root) {
      var w = window.innerWidth;
      if (w <= 768) return parseInt(root.getAttribute('data-slides-mobile'), 10) || 1;
      if (w <= 990) return parseInt(root.getAttribute('data-slides-tablet'), 10) || 2;
      return parseInt(root.getAttribute('data-slides-desktop'), 10) || 3;
    }

    function initCarousel(root) {
      var track = root.querySelector('[data-krs-track]');
      if (!track) return null;

      var prevBtn = root.querySelector('[data-krs-prev]');
      var nextBtn = root.querySelector('[data-krs-next]');
      var dotsWrap = root.querySelector('[data-krs-dots]');
      var viewport = root.querySelector('[data-krs-viewport]');
      var slides = track.children;
      var index = 0;
      var touchStartX = 0;
      var dotBtns = [];

      function maxIndex() {
        return Math.max(0, slides.length - slidesPerView(root));
      }

      function pageCount() {
        return maxIndex() + 1;
      }

      function getStep() {
        if (slides.length < 2) return slides[0] ? slides[0].getBoundingClientRect().width : 0;
        return Math.round(slides[1].getBoundingClientRect().left - slides[0].getBoundingClientRect().left);
      }

      function renderDots() {
        if (!dotsWrap) return;
        dotsWrap.innerHTML = '';
        dotBtns = [];
        var pages = pageCount();
        if (pages <= 1) return;

        for (var i = 0; i < pages; i++) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'koios-recipe-showcase__dot' + (i === index ? ' is-active' : '');
          btn.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          btn.setAttribute('role', 'tab');
          btn.setAttribute('aria-selected', i === index ? 'true' : 'false');
          (function (page) {
            btn.addEventListener('click', function () { goTo(page); });
          })(i);
          dotsWrap.appendChild(btn);
          dotBtns.push(btn);
        }
      }

      function updateDots() {
        dotBtns.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === index);
          dot.setAttribute('aria-selected', i === index ? 'true' : 'false');
        });
      }

      function update() {
        index = Math.min(index, maxIndex());
        track.style.transform = 'translateX(-' + index * getStep() + 'px)';
        if (prevBtn) prevBtn.disabled = index <= 0;
        if (nextBtn) nextBtn.disabled = index >= maxIndex();
        if (dotBtns.length !== pageCount()) renderDots();
        else updateDots();
      }

      function goTo(i) {
        index = Math.max(0, Math.min(maxIndex(), i));
        update();
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { goTo(index - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { goTo(index + 1); });

      if (root.getAttribute('data-enable-touch') === 'true' && viewport) {
        viewport.addEventListener(
          'touchstart',
          function (e) {
            touchStartX = e.changedTouches[0].screenX;
          },
          { passive: true }
        );
        viewport.addEventListener(
          'touchend',
          function (e) {
            var diff = e.changedTouches[0].screenX - touchStartX;
            if (Math.abs(diff) > 50) goTo(index + (diff > 0 ? -1 : 1));
          },
          { passive: true }
        );
      }

      var onResize = function () {
        var prevPages = pageCount();
        goTo(Math.min(index, maxIndex()));
        if (pageCount() !== prevPages) renderDots();
      };

      window.addEventListener('resize', onResize);
      renderDots();
      update();

      return function cleanup() {
        window.removeEventListener('resize', onResize);
        track.style.transform = '';
      };
    }

    function destroyRoot(root) {
      if (root._krsCleanup) root._krsCleanup();
      root.removeAttribute(INITED);
    }

    function initRoot(root) {
      if (!root || root.getAttribute(INITED) === 'true') return;
      root._krsCleanup = initCarousel(root);
      root.setAttribute(INITED, 'true');
    }

    function initAll(container) {
      var scope = container || document;
      scope.querySelectorAll('[data-koios-recipe-showcase][data-section-id]').forEach(function (root) {
        destroyRoot(root);
        initRoot(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      if (!event || !event.target) return;
      initAll(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      if (!event || !event.target) return;
      event.target.querySelectorAll('[data-koios-recipe-showcase][data-section-id]').forEach(destroyRoot);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["koios-split-spotlight"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var INITED = 'data-koios-split-inited';

    function initRoot(root) {
      if (!root || root.getAttribute(INITED) === 'true') return;

      var video = root.querySelector('[data-koios-split-video]');
      if (!video) {
        root.setAttribute(INITED, 'true');
        return;
      }

      if (root.getAttribute('data-video-autoplay') !== 'true') {
        video.setAttribute('controls', '');
        var url = video.getAttribute('data-src');
        if (url) video.src = url;
        root.setAttribute(INITED, 'true');
        return;
      }

      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var srcLoaded = false;
      var inView = false;

      function lazyLoad() {
        if (srcLoaded) return Promise.resolve();
        var loadUrl = video.getAttribute('data-src');
        if (!loadUrl) return Promise.resolve();
        video.src = loadUrl;
        srcLoaded = true;
        return new Promise(function (resolve) {
          if (video.readyState >= 2) {
            resolve();
            return;
          }
          video.addEventListener(
            'loadeddata',
            function done() {
              video.removeEventListener('loadeddata', done);
              resolve();
            },
            { once: true }
          );
          video.load();
        });
      }

      function play() {
        if (reducedMotion) {
          lazyLoad().then(function () {
            video.setAttribute('controls', '');
          });
          return;
        }
        lazyLoad().then(function () {
          if (!inView) return;
          video.play().catch(function () {
            video.setAttribute('controls', '');
          });
        });
      }

      function pause() {
        video.pause();
        if (!reducedMotion) video.removeAttribute('controls');
      }

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              inView = entry.isIntersecting && entry.intersectionRatio >= 0.35;
              if (inView) play();
              else pause();
            });
          },
          { threshold: [0, 0.35] }
        );
        observer.observe(root);
      } else {
        lazyLoad().then(function () {
          video.setAttribute('controls', '');
        });
      }

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) pause();
      });

      root.setAttribute(INITED, 'true');
    }

    function initAll(container) {
      var scope = container || document;
      var roots = scope.querySelectorAll('[data-koios-split-spotlight][data-section-id]');
      for (var i = 0; i < roots.length; i++) {
        roots[i].removeAttribute(INITED);
        initRoot(roots[i]);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      if (!event || !event.target) return;
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["koios-tab-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var INITED = 'data-koios-tab-inited';

    function slidesPerView(root) {
      var w = window.innerWidth;
      if (w <= 768) return parseInt(root.getAttribute('data-slides-mobile'), 10) || 1;
      if (w <= 1024) return parseInt(root.getAttribute('data-slides-tablet'), 10) || 3;
      return parseInt(root.getAttribute('data-slides-desktop'), 10) || 4;
    }

    function getActivePanel(root) {
      return root.querySelector('.koios-tab-carousel__panel.is-active');
    }

    function buildDots(root, panel, dotsWrap, onSelect) {
      if (!dotsWrap || !panel) return;
      dotsWrap.innerHTML = '';
      var track = panel.querySelector('[data-carousel-track]');
      if (!track) return;
      var slides = track.children;
      var perView = slidesPerView(root);
      var pages = Math.max(1, slides.length - perView + 1);
      if (slides.length <= perView) {
        dotsWrap.hidden = true;
        return;
      }
      dotsWrap.hidden = false;
      for (var d = 0; d < pages; d++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'koios-tab-carousel__dot' + (d === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Go to page ' + (d + 1));
        dot.setAttribute('data-dot-index', String(d));
        dot.addEventListener('click', function () {
          onSelect(parseInt(this.getAttribute('data-dot-index'), 10));
        });
        dotsWrap.appendChild(dot);
      }
    }

    function updateDots(dotsWrap, index) {
      if (!dotsWrap) return;
      var dots = dotsWrap.querySelectorAll('.koios-tab-carousel__dot');
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('is-active', i === index);
      }
    }

    function initCarousel(root) {
      var panel = getActivePanel(root);
      if (!panel) return null;

      var track = panel.querySelector('[data-carousel-track]');
      var prevBtn = root.querySelector('[data-carousel-prev]');
      var nextBtn = root.querySelector('[data-carousel-next]');
      var dotsWrap = root.querySelector('[data-carousel-dots]');
      var controls = root.querySelector('[data-carousel-controls]');
      if (!track) return null;

      var slides = track.children;
      var index = 0;
      var touchStartX = 0;
      var autoplayTimer = null;

      function maxIndex() {
        return Math.max(0, slides.length - slidesPerView(root));
      }

      function getStep() {
        if (slides.length < 2) return slides[0].getBoundingClientRect().width;
        var a = slides[0].getBoundingClientRect();
        var b = slides[1].getBoundingClientRect();
        return Math.round(b.left - a.left);
      }

      function update() {
        index = Math.min(index, maxIndex());
        track.style.transform = 'translateX(-' + index * getStep() + 'px)';
        if (prevBtn) prevBtn.disabled = index <= 0;
        if (nextBtn) nextBtn.disabled = index >= maxIndex();
        updateDots(dotsWrap, index);
        if (controls) controls.hidden = maxIndex() <= 0;
      }

      function goTo(i) {
        index = Math.max(0, Math.min(maxIndex(), i));
        update();
      }

      buildDots(root, panel, dotsWrap, goTo);

      if (prevBtn) {
        prevBtn.onclick = function () {
          goTo(index - 1);
        };
      }
      if (nextBtn) {
        nextBtn.onclick = function () {
          goTo(index + 1);
        };
      }

      if (root.getAttribute('data-enable-touch') === 'true') {
        panel.addEventListener(
          'touchstart',
          function (e) {
            touchStartX = e.changedTouches[0].screenX;
          },
          { passive: true }
        );
        panel.addEventListener(
          'touchend',
          function (e) {
            var diff = e.changedTouches[0].screenX - touchStartX;
            if (Math.abs(diff) > 50) {
              diff > 0 ? goTo(index - 1) : goTo(index + 1);
            }
          },
          { passive: true }
        );
      }

      function startAutoplay() {
        stopAutoplay();
        if (root.getAttribute('data-autoplay') !== 'true') return;
        var speed = parseInt(root.getAttribute('data-autoplay-speed'), 10) || 5;
        autoplayTimer = window.setInterval(function () {
          if (index >= maxIndex()) goTo(0);
          else goTo(index + 1);
        }, speed * 1000);
      }

      function stopAutoplay() {
        if (autoplayTimer) {
          window.clearInterval(autoplayTimer);
          autoplayTimer = null;
        }
      }

      var resizeHandler = function () {
        buildDots(root, panel, dotsWrap, goTo);
        update();
      };
      window.addEventListener('resize', resizeHandler);
      update();
      startAutoplay();

      return {
        destroy: function () {
          stopAutoplay();
          window.removeEventListener('resize', resizeHandler);
          track.style.transform = '';
        },
        reset: function () {
          index = 0;
          buildDots(root, panel, dotsWrap, goTo);
          update();
        }
      };
    }

    function initRoot(root) {
      if (!root || root.getAttribute(INITED) === 'true') return;

      var tabBtns = root.querySelectorAll('.koios-tab-carousel__tab-btn');
      var panels = root.querySelectorAll('.koios-tab-carousel__panel');
      var carousel = initCarousel(root);

      for (var t = 0; t < tabBtns.length; t++) {
        tabBtns[t].addEventListener('click', function () {
          var tabIndex = parseInt(this.getAttribute('data-tab-index'), 10);

          for (var i = 0; i < tabBtns.length; i++) {
            var active = i === tabIndex;
            tabBtns[i].classList.toggle('is-active', active);
            tabBtns[i].setAttribute('aria-selected', active ? 'true' : 'false');
          }

          for (var p = 0; p < panels.length; p++) {
            var show = p === tabIndex;
            panels[p].classList.toggle('is-active', show);
            if (show) panels[p].removeAttribute('hidden');
            else panels[p].setAttribute('hidden', '');
          }

          if (carousel) carousel.destroy();
          carousel = initCarousel(root);
        });
      }

      root.setAttribute(INITED, 'true');
      root._koiosTabCarousel = carousel;
    }

    function initAll(container) {
      var scope = container || document;
      var roots = scope.querySelectorAll('[data-koios-tab-carousel][data-section-id]');
      for (var i = 0; i < roots.length; i++) {
        roots[i].removeAttribute(INITED);
        initRoot(roots[i]);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      if (!event || !event.target) return;
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["koios-ugc-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var INITED = 'data-kug-inited';

    function parseVideoUrl(raw) {
      if (!raw || typeof raw !== 'string') return null;
      var url = raw.trim().replace(/&amp;/g, '&');
      var m;

      m = url.match(/(?:youtube\.com\/(?:watch\?(?:[^#]*&)?v=|embed\/|shorts\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
      if (m) return { platform: 'youtube', id: m[1], original: url };

      m = url.match(/vimeo\.com\/(?:channels\/[^/]+\/|groups\/[^/]+\/videos\/|video\/|)(\d+)/);
      if (m) return { platform: 'vimeo', id: m[1], original: url };

      m = url.match(/tiktok\.com\/@[^/]+\/video\/(\d+)/);
      if (m) return { platform: 'tiktok', id: m[1], original: url };

      m = url.match(/instagram\.com\/(?:reel|p|tv)\/([A-Za-z0-9_-]+)/);
      if (m) return { platform: 'instagram', id: m[1], original: url.split('?')[0] };

      return null;
    }

    function youtubeThumbUrls(id) {
      return [
        'https://i.ytimg.com/vi/' + id + '/maxresdefault.jpg',
        'https://i.ytimg.com/vi/' + id + '/hqdefault.jpg',
        'https://i.ytimg.com/vi/' + id + '/mqdefault.jpg'
      ];
    }

    function loadImage(src) {
      return new Promise(function (resolve, reject) {
        var img = new Image();
        img.onload = function () { resolve(src); };
        img.onerror = function () { reject(new Error('img')); };
        img.src = src;
      });
    }

    function pickYoutubeThumb(id) {
      var urls = youtubeThumbUrls(id);
      var chain = Promise.reject();
      urls.forEach(function (u) {
        chain = chain.catch(function () { return loadImage(u); });
      });
      return chain.catch(function () { return urls[urls.length - 1]; });
    }

    function oembedUrl(platform, pageUrl) {
      if (platform === 'youtube') {
        return 'https://www.youtube.com/oembed?format=json&url=' + encodeURIComponent(pageUrl);
      }
      if (platform === 'tiktok') {
        return 'https://www.tiktok.com/oembed?url=' + encodeURIComponent(pageUrl);
      }
      return 'https://vimeo.com/api/oembed.json?url=' + encodeURIComponent(pageUrl);
    }

    function fetchOembed(platform, pageUrl) {
      return fetch(oembedUrl(platform, pageUrl), { credentials: 'omit' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }

    function embedSrc(platform, id) {
      if (platform === 'youtube') {
        return 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
      }
      if (platform === 'vimeo') {
        return 'https://player.vimeo.com/video/' + id + '?autoplay=1';
      }
      if (platform === 'tiktok') {
        return 'https://www.tiktok.com/embed/v2/' + id + '?autoplay=1';
      }
      return '';
    }

    function formatHandle(name) {
      if (!name) return '';
      return name.charAt(0) === '@' ? name : '@' + name.replace(/^@/, '');
    }

    function hydrateVideoCard(card) {
      if (!card || card.getAttribute('data-kug-hydrated') === 'true') return;
      card.setAttribute('data-kug-hydrated', 'true');

      var url = card.getAttribute('data-video-url') || '';
      var thumbOverride = card.getAttribute('data-thumb-url') || '';
      var handleOverride = card.getAttribute('data-handle') || '';
      var externalOnly = card.getAttribute('data-external-only') === 'true';
      var img = card.querySelector('.koios-ugc-gallery__image');
      var handleEl = card.querySelector('[data-kug-handle]');
      var parsed = parseVideoUrl(url);

      if (handleOverride && handleEl) {
        handleEl.textContent = formatHandle(handleOverride);
      }

      if (thumbOverride && img) {
        img.removeAttribute('hidden');
        img.src = thumbOverride;
        img.alt = handleOverride || 'Social video';
        return;
      }

      if (!parsed) {
        if (handleEl && !handleOverride) handleEl.textContent = 'Invalid URL';
        return;
      }

      if (parsed.platform === 'instagram' || externalOnly) {
        return;
      }

      function showThumb(src, alt) {
        if (!img || !src) return;
        img.removeAttribute('hidden');
        img.src = src;
        img.alt = alt || 'Video thumbnail';
      }

      if (parsed.platform === 'youtube') {
        pickYoutubeThumb(parsed.id).then(function (src) {
          showThumb(src, 'YouTube video');
        });
      }

      fetchOembed(parsed.platform, parsed.original).then(function (data) {
        if (data && data.thumbnail_url) {
          showThumb(data.thumbnail_url, data.title || 'Video');
        }
        if (data && data.author_name && handleEl && !handleOverride) {
          handleEl.textContent = formatHandle(data.author_name);
        }
      });
    }

    function observeVideoCards(root) {
      var cards = root.querySelectorAll('.koios-ugc-gallery__card.is-video');
      if (!cards.length) return;

      if (!('IntersectionObserver' in window)) {
        cards.forEach(hydrateVideoCard);
        return;
      }

      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (en) {
            if (!en.isIntersecting) return;
            hydrateVideoCard(en.target);
            io.unobserve(en.target);
          });
        },
        { rootMargin: '120px 0px', threshold: 0.01 }
      );

      cards.forEach(function (card) {
        io.observe(card);
      });
    }

    function initModal(root) {
      var modal = root.querySelector('[data-kug-modal]');
      var dialog = root.querySelector('[data-kug-modal-dialog]');
      var iframe = root.querySelector('[data-kug-modal-iframe]');
      if (!modal || !iframe) return;

      function closeModal() {
        modal.hidden = true;
        iframe.removeAttribute('src');
        if (dialog) dialog.classList.remove('is-portrait');
        document.body.classList.remove('koios-ugc-modal-open');
      }

      function openFromCard(card) {
        var url = card.getAttribute('data-video-url') || '';
        var parsed = parseVideoUrl(url);
        if (!parsed) return;

        if (card.getAttribute('data-external-only') === 'true' || parsed.platform === 'instagram') {
          window.open(parsed.original || url, '_blank', 'noopener,noreferrer');
          return;
        }

        hydrateVideoCard(card);
        var src = embedSrc(parsed.platform, parsed.id);
        if (!src) return;

        if (dialog) {
          dialog.classList.toggle('is-portrait', parsed.platform === 'tiktok');
        }
        iframe.src = src;
        modal.hidden = false;
        document.body.classList.add('koios-ugc-modal-open');
      }

      root.querySelectorAll('[data-kug-open-video]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var card = btn.closest('.koios-ugc-gallery__card.is-video');
          if (card) openFromCard(card);
        });
      });

      root.querySelectorAll('[data-kug-modal-close]').forEach(function (el) {
        el.addEventListener('click', closeModal);
      });

      root._kugModalKeydown = function (e) {
        if (e.key === 'Escape' && !modal.hidden) closeModal();
      };
      document.addEventListener('keydown', root._kugModalKeydown);
      root._kugCloseModal = closeModal;
    }

    function slidesPerView(root) {
      var w = window.innerWidth;
      if (w <= 768) return parseInt(root.getAttribute('data-slides-mobile'), 10) || 1;
      if (w <= 990) return parseInt(root.getAttribute('data-slides-tablet'), 10) || 2;
      return parseInt(root.getAttribute('data-slides-desktop'), 10) || 3;
    }

    function initCarousel(root) {
      var track = root.querySelector('[data-kug-track]');
      if (!track) return null;

      var prevBtns = root.querySelectorAll('[data-kug-prev]');
      var nextBtns = root.querySelectorAll('[data-kug-next]');
      var slides = track.children;
      var index = 0;
      var touchStartX = 0;
      var viewport = root.querySelector('[data-kug-viewport]');

      function maxIndex() {
        return Math.max(0, slides.length - slidesPerView(root));
      }

      function getStep() {
        if (slides.length < 2) return slides[0] ? slides[0].getBoundingClientRect().width : 0;
        return Math.round(slides[1].getBoundingClientRect().left - slides[0].getBoundingClientRect().left);
      }

      function update() {
        index = Math.min(index, maxIndex());
        track.style.transform = 'translateX(-' + index * getStep() + 'px)';
        prevBtns.forEach(function (btn) { btn.disabled = index <= 0; });
        nextBtns.forEach(function (btn) { btn.disabled = index >= maxIndex(); });
      }

      function goTo(i) {
        index = Math.max(0, Math.min(maxIndex(), i));
        update();
      }

      prevBtns.forEach(function (btn) {
        btn.addEventListener('click', function () { goTo(index - 1); });
      });
      nextBtns.forEach(function (btn) {
        btn.addEventListener('click', function () { goTo(index + 1); });
      });

      if (root.getAttribute('data-enable-touch') === 'true' && viewport) {
        viewport.addEventListener(
          'touchstart',
          function (e) {
            touchStartX = e.changedTouches[0].screenX;
          },
          { passive: true }
        );
        viewport.addEventListener(
          'touchend',
          function (e) {
            var diff = e.changedTouches[0].screenX - touchStartX;
            if (Math.abs(diff) > 50) goTo(index + (diff > 0 ? -1 : 1));
          },
          { passive: true }
        );
      }

      var onResize = function () { goTo(index); };
      window.addEventListener('resize', onResize);
      update();

      return function cleanup() {
        window.removeEventListener('resize', onResize);
        track.style.transform = '';
      };
    }

    function destroyRoot(root) {
      if (root._kugCleanup) root._kugCleanup();
      if (root._kugModalKeydown) {
        document.removeEventListener('keydown', root._kugModalKeydown);
        root._kugModalKeydown = null;
      }
      if (root._kugCloseModal) root._kugCloseModal();
      root.removeAttribute(INITED);
    }

    function initRoot(root) {
      if (!root || root.getAttribute(INITED) === 'true') return;
      observeVideoCards(root);
      initModal(root);
      root._kugCleanup = initCarousel(root);
      root.setAttribute(INITED, 'true');
    }

    function initAll(container) {
      var scope = container || document;
      scope.querySelectorAll('[data-koios-ugc-gallery][data-section-id]').forEach(function (root) {
        destroyRoot(root);
        initRoot(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      if (!event || !event.target) return;
      initAll(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      if (!event || !event.target) return;
      event.target.querySelectorAll('[data-koios-ugc-gallery][data-section-id]').forEach(destroyRoot);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
